import React from 'react';
import { Helmet } from 'react-helmet';
import favIconPc from '../../../../static/favicon.ico';

const GatsbyHead = (props) => {
  const siteName = props.siteName;

  const attrs = {
    titleTemplate: siteName && props?.showSiteName ? `${siteName}` : null,
    meta: [
      {
        property: `og:type`,
        content: `website`
      },
      {
        name: `twitter:card`,
        content: `summary`
      },
      {
        name: `twitter:creator`,
        content: ''
      }
    ]
  };

  if (props.lang) {
    attrs.htmlAttributes = {
      lang: props.lang
    };
  }

  if (props.title) {
    attrs.title = props.title;
  }

  if (props.description) {
    attrs.meta.push({
      name: `description`,
      content: props.description
    });
  }

  if (props.ogTitle || props.title) {
    attrs.meta.push({
      property: `og:title`,
      content: `${props.ogTitle || props.title} | ${siteName}`
    });
  }

  if (props.ogDescription || props.description) {
    attrs.meta.push({
      property: `og:description`,
      content: props.ogDescription || props.description
    });
  }

  if (props.twTitle || props.ogTitle || props.title) {
    attrs.meta.push({
      name: `twitter:title`,
      content: `${props.twTitle || props.ogTitle || props.title} | ${siteName}`
    });
  }

  if (props.twDescription || props.ogDescription || props.description) {
    attrs.meta.push({
      name: `twitter:description`,
      content: props.twDescription || props.ogDescription || props.description
    });
  }

  if (props.meta) {
    attrs.meta.concat(props.meta);
  }

  return (
    <Helmet link={[{ rel: 'icon', type: 'image/ico', href: favIconPc }]} {...attrs}>
      {props.children}
    </Helmet>
  );
};

export default GatsbyHead;
